import { Routes } from '@angular/router';
import { environment } from 'environments/environment';



export let Full_ROUTES: Routes = environment.todos;

